/**
 * cart-reservation-timer.js — Persistent countdown that survives cart drawer
 * re-renders. Uses setInterval to update any .js-cart-reservation-countdown
 * elements found in the DOM (they get replaced on each cart re-render).
 */
(function () {
  'use strict';

  var KEY = 'cart_reservation_start';
  var DURATION = 600; // 10 minutes

  function getStart() {
    var stored = sessionStorage.getItem(KEY);
    var start = stored ? parseInt(stored, 10) : 0;
    var now = Math.floor(Date.now() / 1000);
    if (!stored || (now - start) >= DURATION) {
      start = now;
      sessionStorage.setItem(KEY, String(start));
    }
    return start;
  }

  var start = getStart();

  function tick() {
    var elapsed = Math.floor(Date.now() / 1000) - start;
    var remaining = Math.max(0, DURATION - elapsed);
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;
    var text = m + ':' + (s < 10 ? '0' : '') + s;

    var els = document.querySelectorAll('.js-cart-reservation-countdown');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = text;
    }

    if (remaining <= 0) {
      // Reset for next cycle
      start = getStart();
    }
  }

  // Run every second — always finds fresh DOM elements after re-renders
  setInterval(tick, 1000);
  tick();
})();
